/* eslint-disable react/require-default-props */
import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';

const InputContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 4px;
  margin: 8px auto;
`;

const InputLabel = styled.label`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 14px;
  margin-bottom: 8px;
  display: inline-block;
`;

const InputSubLabel = styled.div`
  font-family: Lato;
  font-style: italic;
  font-weight: normal;
  font-size: 1rem;
  line-height: 14px;
  margin-bottom: 0.6rem;
  color: #484848;  
`;

const InputFieldContainer = styled.div<{ error: boolean; disabled: boolean }>`
  width: 100%;
  padding: 8px;
  border: 2px solid ${({ error }) => (error ? '#EA0000' : '#DBDEE2')};
  border-radius: 4px;
  background-color: ${({ disabled }) => (disabled ? '#DBDEE2' : 'unset')};
`;

const InputField = styled.input<{ disabled: boolean }>`
  font-family: Lato;
  width: 100%;
  border: none;
  outline-width: 0;
  background-color: ${({ disabled }) => (disabled ? '#DBDEE2' : 'initial')};
`;

const InputHelper = styled.div<{ error: boolean; helperColor?: string }>`
  color: ${({ error, helperColor }) => helperColor || (error ? '#EA00000' : 'unset')};
  text-align: left;
  font-size: 1rem;
`;

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  readOnly?: boolean;
  error?: string;
  label: string;
  sublabel?: string;
  helperColor?: string;
  helper?: string;
}

const TextInput = ({
  className,
  label,
  sublabel,
  helper,
  error,
  readOnly = false,
  autoFocus,
  type,
  defaultValue,
  helperColor,
  placeholder,
  required,
  onChange,
  onKeyPress,
}: TextInputProps) => (
  <InputContainer className={className}>
    <InputLabel>
      {label}
    </InputLabel>
    {sublabel && (
      <InputSubLabel>
        {sublabel}
      </InputSubLabel>
    )}
    <InputFieldContainer disabled={readOnly} error={!!error}>
      <InputField
        autoFocus={autoFocus}
        readOnly={readOnly}
        required={required}
        defaultValue={defaultValue}
        disabled={readOnly}
        placeholder={placeholder}
        onChange={onChange}
        onKeyUp={onKeyPress}
        type={type}
      />
    </InputFieldContainer>
    {!!helper && (
      <InputHelper error={!!error} helperColor={helperColor}>
        {helper}
      </InputHelper>
    )}
  </InputContainer>
);

export default TextInput;
